var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero-section'),_c('problem-section'),_c('how-it-works-section'),_c('formula-section'),_c('regulation-section'),_c('kpi-section'),_c('contours-section'),_c('features-section'),_c('telegram-section'),_c('interface-section'),_c('audience-section'),_c('demo-offer-section'),_c('faq-section'),_c('cta-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }